export default __webpack_public_path__ + "static/underline-16-mobile-8a9445e389184b64c0fb1676131949fe.svg";